export const getGrade = (mark) => {
  mark = parseFloat(mark);

  if (mark >= 89.995) {
    return "A++";
  } else if (mark >= 79.995) {
    return "A+";
  } else if (mark >= 69.995) {
    return "A";
  } else if (mark >= 59.995) {
    return "A-";
  } else if (mark >= 49.995) {
    return "B";
  } else {
    return "C";
  }
};

export const getRemark = (mark) => {
  mark = parseFloat(mark);

  if (mark >= 89.995) {
    return "Outstanding Achievement";
  } else if (mark >= 79.995) {
    return "Satisfactory Achievement";
  } else if (mark >= 69.995) {
    return "Improvement Needed";
  } else {
    return "Good Effort";
  }
};
